// Implementation as per https://www.detectadblock.com/
// - We host a honeypot ad file with a suspcious name
//   - The ad file in /static/google-adsense.js is deployed to our S3 bucket
//     as part of the semantic release process.
// - Try to load that file, which ads a div with a unique ID
// - If that div is not present, then the adblocker is blocking it
export const getIsAdBlockEnabled = () => {
  const script = document.createElement('script');
  script.src =
    'https://cdn.rebilly.com/risk-data-collector/@latest/google-adsense.js';

  return new Promise<boolean>((resolve) => {
    script.onload = () => {
      resolve(document.getElementById('fj2xFkdsoQIQna') === null);
    };
    script.onerror = () => {
      return resolve(true);
    };
    document.head.appendChild(script);
  }).catch(() => {
    return true;
  });
};
